import { EVCPreset } from "@rvi/asset-modules";
import { definePreset } from "@primeuix/themes";

export const VisolPreset = definePreset(EVCPreset, {
  // overrides here
});
